import React from 'react';
import { Bell, Home, BookOpen, BarChart2, Award, Settings, Plus, Menu } from 'lucide-react';
interface HeaderProps {
  onOpenSidebar?: () => void;
}
export function Header({
  onOpenSidebar
}: HeaderProps) {
  return;
}
function NavItem({
  icon,
  label,
  active = false
}) {
  return <div className={`flex items-center cursor-pointer ${active ? 'text-red-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1075">
      <span className="mr-2" data-id="element-1076">{icon}</span>
      <span className="text-sm" data-id="element-1077">{label}</span>
    </div>;
}